/**
 * 业务错误码 → 兜底文案（后端 message 缺失时使用）。
 * 权威来源：docs/前端状态码清单_20260921.md §一。
 * 后端统一返回 { code, data, message }，message 为 toast 首选文案，本表仅兜底。
 */
export default {
  // 通用/框架码（9xxxx）
  '90001': '参数错误',
  '90002': '未登录或登录已过期',
  '90003': '无权限',
  '90004': '资源不存在',
  '90005': '重复请求',
  '90006': '请求过于频繁',
  '99999': '系统异常，请稍后重试',
  // identity 用户域（1xxxx）
  '10001': '账号或凭证错误',
  '10002': '账号已锁定',
  '10003': '账号状态异常',
  '10004': '该终端无可用身份',
  '10005': '身份未绑定有效角色',
  '10006': 'token 无效或已过期',
  '10007': '请输入图形验证码',
  '10008': '图形验证码错误',
  // fund 资金域（3xxxx）
  '30001': '余额不足',
  '30002': '余额不能为负',
  '30003': '池级守恒校验失败',
  '30004': '获取分布式锁失败',
  // college 商学院域（6xxxx）：后端 message 会带具体数量/题号，这里只是它缺失时的兜底
  '63001': '该分类（含子级）被题目引用为知识点，不能删除，请先调整这些题目的知识点',
  '63002': '发布失败：考试含已停用题目，请先在题库启用或替换后再发布',
  // 兼容旧模板
  '401': '认证失败，无法访问系统资源',
  '403': '当前操作没有权限',
  '404': '访问资源不存在',
  default: '系统未知错误，请反馈给管理员'
}
